import classNames from 'classnames'
import { JSX } from 'react'

import { Checkbox, ICheckboxProps } from 'core-components/library/checkbox'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn = (props: ICheckboxProps) => JSX.Element

const applyDisabled = (component: TComponentFn) => {
  return (props: ICheckboxProps) => {
    const { disabled, className } = props
    const disabledTheme = disabled ? themesStyles.disabledCheckbox : undefined

    return component({
      ...props,
      className: classNames(className, disabledTheme),
    })
  }
}

export const OnboardingCheckbox = (props: ICheckboxProps) =>
  applyDisabled(createComponentFn<ICheckboxProps & JSX.IntrinsicAttributes>(Checkbox))(props)
